import { FunctionComponent } from 'react'

import { RootStackScreenComponentProps } from 'src/navigation'

export type HiringScreenComponent = FunctionComponent<HiringScreenProps>

export type HiringScreenProps = RootStackScreenComponentProps<'Hiring'>

export type ResponsiveHiringScreenComponent = FunctionComponent<ReturnType<UseHiringScreen>>

export type UseHiringScreen = ({ navigation }: Pick<HiringScreenProps, 'navigation' | 'route'>) => {
  isMobile: boolean
  url?: string
}

// PowerApps URLs constants
export const POWERAPPS_BASE_URL =
  'https://apps.powerapps.com/play/e/fa202e3d-3516-e92f-a526-7811aa5d3b46'

export const TENANT_ID = '35595a02-4d6d-44ac-99e1-f9ab4cd872db'

export const HIRING_URLS = {
  WALLETS_MANAGEMENT: `${POWERAPPS_BASE_URL}/a/740e86d0-33d7-4e32-b77d-0b6887c5e0d0?tenantId=${TENANT_ID}&hint=ae2d9b16-9ae5-461a-80e0-b7d96a8f013f&sourcetime=1768325336751`,
  GOALS: `${POWERAPPS_BASE_URL}/a/8f88de47-1f87-4d07-9824-13947a2de028?tenantId=${TENANT_ID}&hint=d046ded4-e63b-469e-b7bb-e38aa85319d8&sourcetime=1776455102408`,
  DELEGATION: `${POWERAPPS_BASE_URL}/a/a68b9a25-9c68-42bb-83e4-93b08620ab91?tenantId=${TENANT_ID}&hint=fa8c3a50-25e4-4a0a-9435-a50159dd5d4b&sourcetime=1755021094604`,
  MIGRATION: `${POWERAPPS_BASE_URL}/a/2d98fe74-22c4-4046-87a6-6f1dff41b23a?tenantId=${TENANT_ID}&hint=a5e60d37-78ab-46fb-8ebf-773ad640d216&sourcetime=1762798560352`,
  MOVEMENT: `${POWERAPPS_BASE_URL}/a/7a678cf4-0fe6-4574-a4ba-39ed19f78eab?tenantId=${TENANT_ID}&hint=b9be5e1e-de1e-4c9b-b05f-aba9ab9e17fa&sourcetime=1768325215464`
} as const
